import React, { useState, useEffect } from "react";
// import "../verifymail.css";
import "../../../GlobalCss/SPF/Login.css";
import { Link, useHistory } from "react-router-dom";
import { Button, Image, Input, message } from "antd";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import axios from "axios";
import { encodeRoute, routes } from "../../../Utils/Utils";


const SendOtp = ({ history }) => {
  const [email, setEmail] = useState("");
  const [inputFocused, setInputFocused] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
  const tenantName = Cookies.get("tenant_name")
  const url =  `/${tenantName}`

  useEffect(() => {
    const storedEmail = Cookies.get("email");
    if (storedEmail) setEmail(storedEmail);

    const authKey = Cookies.get("authKey");
    if(!authKey){
      history.replace(`/${tenantName}`);
    }

    const jwtToken = Cookies.get("jwt_token");
    const userRole = Cookies.get("Role");
    const reqRole = "Super User";
    if (jwtToken !== undefined && userRole === reqRole) {
      window.location.href = `/${tenantName}/admin-dashboard`;
    } else if (jwtToken !== undefined && userRole === "User") {
      window.location.href = `/${tenantName}/dashboard`;
    }
  }, []);

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };
  const handleSendOTP = () => {
    axios.post(`${process.env.REACT_APP_BASE_URL}Auth/signin/send-otp`, {
      email,
      key:  Cookies.get("authKey")
    })
      .then((response) => {

        if (response.status === 200) {

          // history.push("/verifymail");
          // setTimeout(() => {
          //   message.success(response.data.message);
          //   Cookies.remove("authKey");
          // }, 2000);
          message.success(response.data.message);
          Cookies.remove("authKey")
          // history.replace(`/${tenantName}/${routes.verifyMail}`);
          history.replace(`/${tenantName}/verifymail`);


        } else {

          message.error(response.data.message);
        }
      })
      .catch((error) => {

        // console.error("Error sending OTP:", error);

        if (error.response && error.response.data && error.response.data.message) {

          message.error(error.response.data.message);
        } else {

          message.error("An error occurred while sending OTP.");
        }
      });
  };


  const handleInputFocus = () => {
    setInputFocused(true);
  };

  const handleInputBlur = () => {
    setInputFocused(false);
  };

  return (
    <>
      <div style={{ height: "100%", width: "100%" }}>
        <div className="signin-screen">
          <div className="signin-image">
            <Image
              src="/Images/illus3.png"
              style={{
                border: "none",
                width: "90%",
                height: "100%",
              }}
              showPreviewIcon={false}
              preview={false}
            />
          </div>
          <div className="signin-col">
            <div className="card-border">
              <h1 className="mfa">Multi-Factor Authentication</h1>
              <div className="mfa-image">
                <div>
                  <Image
                    src="/Images/LogoMain.jpg"
                    style={{
                      border: "none",
                      width: "150px",
                    }}
                    showPreviewIcon={false}
                    preview={false}
                  />
                </div>
              </div>
              <p>Please type your email address </p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <Input
                  placeholder="Enter your Email"
                  value={email}
                  onChange={handleInputChange}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                  disabled={!!email}
                  style={{
                    backgroundColor:
                      inputFocused || email ? "#F0F5FF" : "white",
                    color: inputFocused || email ? "black" : "#ccc",
                  }}
                />
                <Button
                  style={{
                    backgroundColor:
                      email || buttonHovered ? "white" : "#D9D9D9",
                    color: email || buttonHovered ? "#3B52DF" : "white",
                    border:
                      email || buttonHovered
                        ? "1px solid #3B52DF"
                        : "1px solid #D9D9D9",
                  }}
                  disabled={!email}
                  onClick={handleSendOTP}
                >
                  Send OTP <ArrowRightOutlined />
                </Button>
              </div>
              <h4>
                <Link to="/">
                  <ArrowLeftOutlined /> Edit email address
                </Link>
              </h4>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default SendOtp;
